<template>
    <div class="text-center container-ready">
        <v-row>
            <v-col cols="12">
                <img src="@/assets/images/tick.svg" alt="" width="150" height="150">
            </v-col>
            <v-col cols="12">
                <h1>Ya has respondido la encuesta!</h1>
                <h1>Gracias por contestarla.</h1>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    export default {
        name: "RomaSurveyReady"
    }
</script>

<style lang="scss" scoped>
    .container-ready {
        img {
            margin-bottom: 10px;
        }
        h1 {
            text-align: center;
            letter-spacing: 0;
            color: #484848;
            font-family: Regular, 'Cabin', serif;
            font-size: 26px;
            opacity: 1;
        }
    }

    @media (max-width: 800px) {
        .container-ready {
            margin-bottom: 20px;
            img {
                margin-bottom: 5px;
                width: 80px;
                height: 80px;
            }
            h1 {
                width: 100%;
                font-size: 18px;
                opacity: 1;
            }
            }
        }


</style>